export const bookProduct = `query {
  products(limit: 1) {
    id
    title
    variants {
      id
      price
      title
    }
  }
}`
